export const GLOBEL_CHANGE_LOADING = "GLOBEL/CHANGE_LOADING";
